var $ = global.jQuery = global.$;

var _Base = require('./_Base');

var SectionNav = _Base.extend({
  init: function() {
    var self = this;

    this.$toggle = this.$el.find('[data-section-toggle]');
    this.$icon = this.$toggle.find('.icon');
    this.$dropdown = this.$el.find('[data-section-dropdown]');

    this.isOpen = false;

    this.classes = {
      open: 'is-open',
      upArrow: 'icon--arrow-up',
      downArrow: 'icon--arrow-down'
    };

    this.$toggle.on('click', function(event) {
      event.preventDefault();
      return self.isOpen ? self.close() : self.open();
    });
  },

  close: function() {
    this.$dropdown.velocity('slideUp');
    this.$icon.removeClass(this.classes.upArrow);
    this.$icon.addClass(this.classes.downArrow);
    this.$el.removeClass(this.classes.open);
    this.isOpen = false;
  },

  open: function() {
    this.$dropdown.velocity('slideDown');
    this.$icon.removeClass(this.classes.downArrow);
    this.$icon.addClass(this.classes.upArrow);
    this.$el.addClass(this.classes.open);
    this.isOpen = true;
  }
});

module.exports = SectionNav;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/SectionNav.js
// module id = 23
// module chunks = 0 1